var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _path11, _path12, _defs, _ellipse, _path13, _path14, _path15, _g3, _path16, _g4, _path17, _path18, _circle, _path19, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g5, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4F7FA;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{opacity:0.3;fill:url(#SVGID_00000145736943772634867170000012525123638993005442_);enable-background:new    ;}\r\n\t.st3{fill:url(#SVGID_00000071533147828355662110000016492201478907068321_);}\r\n\t.st4{opacity:0.3;fill:url(#SVGID_00000069379134725095964040000003752976545367944075_);enable-background:new    ;}\r\n\t.st5{fill:url(#SVGID_00000073698372135008351420000009903314980954849199_);}\r\n\t.st6{fill:url(#SVGID_00000034081902402987768860000017922493361355065226_);}\r\n\t.st7{fill:url(#SVGID_00000148647597197796497110000004778041556814709121_);}\r\n\t.st8{fill:url(#SVGID_00000144335798403093486620000003024842484495404459_);}\r\n\t.st9{fill:url(#SVGID_00000022554039438614051470000006544613461242307763_);}\r\n\t.st10{fill:#FFFFFF;}\r\n\t.st11{fill:#D8DEE8;}\r\n\t.st12{fill:url(#SVGID_00000139294369113458433950000011684202589613250964_);}\r\n\t.st13{fill:url(#SVGID_00000126309722880558316100000013562611681098024108_);}\r\n\t.st14{fill:url(#SVGID_00000010268857134021147910000016555485953859476108_);}\r\n\t.st15{fill:url(#SVGID_00000165207713087296647410000001846022477989001373_);}\r\n\t.st16{fill:url(#SVGID_00000031906395815113252390000004504503172807167916_);}\r\n\t.st17{fill:url(#SVGID_00000176749126895620415220000016992960888387458481_);}\r\n\t.st18{fill:url(#SVGID_00000044157995347975806240000004502799798392301755_);}\r\n\t.st19{fill:url(#SVGID_00000147915457620996877120000000425672734979922311_);}\r\n\t.st20{opacity:0.3;fill:url(#SVGID_00000143579345075483785480000005623075307229488788_);enable-background:new    ;}\r\n\t.st21{fill:url(#SVGID_00000067928048360505235030000000824315530720452500_);}\r\n\t.st22{fill:url(#SVGID_00000054241683058054408860000011379984742327023516_);}\r\n\t.st23{fill:url(#SVGID_00000099624403243835688580000007738440453582662071_);}\r\n\t.st24{fill:url(#SVGID_00000162310405450564050320000012432112452094853288_);}\r\n\t.st25{fill:url(#SVGID_00000150802137642777512430000012904860550279626410_);}\r\n\t.st26{opacity:0.4;fill:url(#SVGID_00000036946021519186622730000015928722784296472479_);enable-background:new    ;}\r\n\t.st27{fill:url(#SVGID_00000158707648760733229620000017171586988583688597_);}\r\n\t.st28{fill:url(#SVGID_00000049195988138873438220000006122047718510826920_);}\r\n\t.st29{fill:url(#SVGID_00000183931710432292737710000002110268534334333058_);}\r\n\t.st30{fill:url(#SVGID_00000065068810515545545890000003697238522723913656_);}\r\n\t.st31{fill:url(#SVGID_00000074443076026918384760000001589180520243898543_);}\r\n\t.st32{fill:url(#SVGID_00000119816507951950489050000006598961556287750571_);}\r\n\t.st33{fill:url(#SVGID_00000021805605932204790780000003136808044639868606_);}\r\n\t.st34{fill:url(#SVGID_00000123400198141384019240000004622213981872263345_);}\r\n\t.st35{fill:url(#SVGID_00000176003616458947910290000016228585532691828357_);}\r\n\t.st36{fill:url(#SVGID_00000096030316066442338120000011185245720677423539_);}\r\n\t.st37{opacity:0.3;fill:url(#SVGID_00000027584849663362802990000013397734909871729539_);enable-background:new    ;}\r\n\t.st38{fill:url(#SVGID_00000183210320911644064820000013233897460280206209_);}\r\n\t.st39{fill:url(#SVGID_00000145774691322276563500000000398289355246112129_);}\r\n\t.st40{fill:url(#SVGID_00000129925169440873850040000008507068333476809103_);}\r\n\t.st41{fill:url(#SVGID_00000052085366077462195130000000053576479284295835_);}\r\n\t.st42{fill:url(#SVGID_00000108271052131065173570000017884721713700675231_);}\r\n\t.st43{fill:url(#SVGID_00000068641466213111183450000013429601595149541802_);}\r\n\t.st44{fill:url(#SVGID_00000003812665947627417560000013324916335061221521_);}\r\n\t.st45{fill:url(#SVGID_00000097494532563685488900000014220293055920098449_);}\r\n\t.st46{fill:#26264F;}\r\n\t.st47{opacity:0.4;}\r\n\t.st48{fill:url(#SVGID_00000029753592591203627610000016101312327638847649_);}\r\n\t.st49{clip-path:url(#SVGID_00000131329056108734141410000012851648233938109335_);}\r\n\t.st50{fill:url(#SVGID_00000111156623858538831060000011290399618323007383_);}\r\n\t.st51{opacity:0.4;fill:url(#SVGID_00000168083479669045672140000009116872423493424545_);enable-background:new    ;}\r\n\t.st52{fill:url(#SVGID_00000001626860747160447770000004410237028089776514_);}\r\n\t.st53{fill:url(#SVGID_00000107587063776222636760000011532312110536650134_);}\r\n\t.st54{fill:url(#SVGID_00000040568307381268549090000017580573530605339289_);}\r\n\t.st55{fill:url(#SVGID_00000067222169917142165800000004910725675250423438_);}\r\n\t.st56{fill:url(#SVGID_00000073708626961593735860000011382412099248087441_);}\r\n\t.st57{opacity:0.3;fill:url(#SVGID_00000113325044847738457830000002643829602219309243_);enable-background:new    ;}\r\n\t.st58{fill:url(#SVGID_00000065794477362130064760000013739297675583742638_);}\r\n\t.st59{fill:url(#SVGID_00000038379327425465721570000010497197665490068871_);}\r\n\t.st60{fill:url(#SVGID_00000011721273843503518730000002787176403524006799_);}\r\n\t.st61{fill:url(#SVGID_00000120551376071140236480000009527165837245979558_);}\r\n\t.st62{fill:url(#SVGID_00000163058624447974818320000000738784300796723902_);}\r\n\t.st63{opacity:0.3;}\r\n\t.st64{fill:url(#SVGID_00000165229454466639874050000007119085578894312091_);}\r\n\t.st65{fill:url(#SVGID_00000114066732927447871760000005995339128573969317_);}\r\n\t.st66{fill:url(#SVGID_00000160897135868746725880000014368844354905682325_);}\r\n\t.st67{fill:url(#SVGID_00000150781183805231743270000016058193047777525392_);}\r\n\t.st68{fill:url(#SVGID_00000169525555126904566720000018384993029162713491_);}\r\n\t.st69{fill:url(#SVGID_00000142860718284929266570000001003664491589650836_);}\r\n\t.st70{fill:url(#SVGID_00000031180805768840098540000015015906224125548690_);}\r\n\t.st71{fill:url(#SVGID_00000132788793788427857220000017313745611834996367_);}\r\n\t.st72{fill:url(#SVGID_00000035508042239122181840000012696466932697292471_);}\r\n\t.st73{fill:url(#SVGID_00000134957225212472742550000006631423766444626841_);}\r\n\t.st74{fill:url(#SVGID_00000061473380898246135880000006103479799875508626_);}\r\n\t.st75{fill:url(#SVGID_00000072244000601160194280000015282291249994784155_);}\r\n\t.st76{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st77{opacity:0.05;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st78{opacity:0.2;enable-background:new    ;}\r\n\t.st79{fill:url(#SVGID_00000021836022611678097860000004079941763809419670_);}\r\n\t.st80{fill:#53A72B;}\r\n\t.st81{fill:#1F6E27;}\r\n\t.st82{fill:#1D2025;}\r\n\t.st83{fill:#082694;}\r\n\t.st84{fill:#0F1354;}\r\n\t.st85{fill:#F77D02;}\r\n\t.st86{fill:#923402;}\r\n\t.st87{fill:url(#SVGID_00000072978253087543036390000008166721920742473873_);}\r\n\t.st88{opacity:0.15;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st89{fill:#2F2F2F;}\r\n\t.st90{fill:#2539A1;}\r\n\t.st91{fill:#FA9F00;}\r\n\t.st92{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st93{fill:url(#SVGID_00000078757043131139415230000016690007147745908376_);}\r\n\t.st94{fill:url(#SVGID_00000162342165715469388890000005802374049540895387_);}\r\n\t.st95{opacity:0.1;}\r\n\t.st96{fill:url(#SVGID_00000092438955278235823750000010199949483893204097_);}\r\n\t.st97{fill:#216E27;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1898.57,494.54C1181.78,473.38,560.89,993.47,467.08,1675.91c-102.56,746.15,461.93,1417.5,1156.52,1525.03 c863.95,133.75,1701.93-639.99,1626.69-1479.38C3193.6,1089.15,2627.2,516.06,1898.57,494.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5725.584,
    y1: -1648.8489,
    x2: 6200.937,
    y2: -1648.8489,
    gradientTransform: "matrix(-1 0 0 1 7344.7012 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1160.92,913.44c57.15,190.97,324,1182.52,337.81,1099.7c0,0,87.69,7.94,112.05-180.52 c2.45-19.05,4.28-40.1,5.28-63.36c11.01-253.5-4.42-1215.54-101.15-1074.78c-96.69,140.76-86.96,232.49-103.32,76.85 c-16.39-155.67-37.82-307.27-124.47-230.48c-4.94,4.38-9.9,8.87-14.91,13.42C1189.98,629.88,1107.05,733.41,1160.92,913.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090288109814549743370000015259735153459412608_",
    gradientUnits: "userSpaceOnUse",
    x1: 5733.9209,
    y1: -1631.8395,
    x2: 6200.9365,
    y2: -1631.8395,
    gradientTransform: "matrix(-1 0 0 1 7344.7012 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000090288109814549743370000015259735153459412608_)",
      enableBackground: "new"
    },
    d: " M1160.92,913.44c57.15,190.97,324,1182.52,337.81,1099.7c0,0,87.69,7.94,112.05-180.52 c-10.63-127.1-110.95-250.88-150.01-306.06c-58.67-82.82-86.27-96.62-48.31-257.4s10.35-236.08-96.62-467.28 c-48.28-104.35-52.97-187.62-43.62-247.6C1189.98,629.88,1107.05,733.41,1160.92,913.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154425429445266098170000002094712332373553825_",
    gradientUnits: "userSpaceOnUse",
    x1: 6010.1929,
    y1: -2003.4377,
    x2: 6805.1333,
    y2: -2003.4377,
    gradientTransform: "matrix(-0.9938 0.1116 0.1116 0.9938 7620.2344 2582.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0985,
    style: {
      stopColor: "#FEBC46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154425429445266098170000002094712332373553825_)"
    },
    d: "M712.79,1455.76 c163.63,173.6,614.14,510.28,751.23,541.78c30.76,7.07,45.77-1.25,38.18-30.19c0,0-132.65-1352.43-512.6-1391.56 c-50.87-5.23-122.18-2.02-167.55,24.12c-7.83,4.52-14.91,9.45-21.36,14.79c-101.8,84.59-37.9,268.72,6.95,367.59 c16.67,36.81,43.18,67,62.36,102.32c16.29,30.02,21.78,69.92-21.37,66.36c-39.61-3.3-65.42-49.81-101.05-62.8 c-40.43-14.66-72.25,5.09-98.42,54.7C594.01,1247.33,634.15,1372.35,712.79,1455.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111913286211418536440000000240102568444016801_",
    gradientUnits: "userSpaceOnUse",
    x1: 6052.2017,
    y1: -1992.3286,
    x2: 6805.1333,
    y2: -1992.3286,
    gradientTransform: "matrix(-0.9938 0.1116 0.1116 0.9938 7620.2344 2582.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0985,
    style: {
      stopColor: "#FEBC46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000111913286211418536440000000240102568444016801_)",
      enableBackground: "new"
    },
    d: " M712.79,1455.76c163.63,173.6,614.14,510.28,751.23,541.78c-17.71-42.04-38.41-88.82-62.65-140.52 c-143.83-306.8-418.14-244.76-313.21-470.06c104.93-225.34,90.38-447.69-112.65-554.32C855.4,769.51,814.28,678.49,800.69,614.7 c-101.8,84.59-37.9,268.72,6.95,367.59c16.67,36.81,43.18,67,62.36,102.32c16.29,30.02,21.78,69.92-21.37,66.36 c-39.61-3.3-65.42-49.81-101.05-62.8c-40.43-14.66-72.25,5.09-98.42,54.7C594.01,1247.33,634.15,1372.35,712.79,1455.76z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151503786034471125640000003708289481991133882_",
    gradientUnits: "userSpaceOnUse",
    x1: 834.1096,
    y1: -1115.3961,
    x2: 1243.4281,
    y2: -1158.1608,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151503786034471125640000003708289481991133882_)"
    },
    d: "M665.45,2653.59 c-48.9,2.86-88.87-31.32-88.87-76.21V959.63c0-44.88,39.97-79.95,88.87-78.18l2308.14,83.76c37.4,1.36,67.7,34.19,67.7,73.19 v1405.65c0,39-30.3,72.5-67.7,74.69L665.45,2653.59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003810186062515263890000003970324706978367419_",
    gradientUnits: "userSpaceOnUse",
    x1: 1706.6501,
    y1: 135.0869,
    x2: 1793.3727,
    y2: 10.8626,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003810186062515263890000003970324706978367419_)"
    },
    d: "M2170.26,2832.64 c-36.89-12.84-64.47-45.69-72.24-86.06l-53.7-278.82L1585,2484.87l-56.53,290.47c-7.92,40.68,23.78,81.49,60.27,96.48 l192.17,78.89c35.74,14.67,74.16,20.52,112.35,17.09l406.13-36.45c11.87-1.07,21.4-10.86,22.78-23.42 c1.38-12.56,9.7-26.67-1.62-30.61L2170.26,2832.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120545583439737285810000000243716292389590952_",
    gradientUnits: "userSpaceOnUse",
    x1: 1969.1768,
    y1: 103.2418,
    x2: 1836.4502,
    y2: -617.273,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120545583439737285810000000243716292389590952_)"
    },
    d: "M2174.81,2815.69 c-36.85-12.68-64.4-45.11-72.17-84.98L2049,2455.38l-448.13,16.92l-56.47,286.82c-7.91,40.17,13.02,80.45,49.48,95.24 l191.98,77.9c35.71,14.49,74.09,20.26,112.24,16.87l405.72-35.99c11.86-1.05,21.37-10.72,22.75-23.12 c1.38-12.4-5.75-24.11-17.06-28L2174.81,2815.69z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083050511737273147360000009773955617150495887_",
    gradientUnits: "userSpaceOnUse",
    x1: 2296.5911,
    y1: -1885.7842,
    x2: 2960.7949,
    y2: -2833.7563,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083050511737273147360000009773955617150495887_)"
    },
    d: "M683.72,2653.59 c-48.9,2.86-88.87-31.32-88.87-76.21V959.63c0-44.88,39.97-79.95,88.87-78.18l2308.14,83.76c37.4,1.36,67.7,34.19,67.7,73.19 v1405.65c0,39-30.3,72.5-67.7,74.69L683.72,2653.59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022542117278647762750000009518868659012475287_",
    gradientUnits: "userSpaceOnUse",
    x1: 2008.1115,
    y1: -1773.2257,
    x2: 1177.2797,
    y2: 865.6093,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022542117278647762750000009518868659012475287_)"
    },
    d: "M2991.87,998.27l-2308.14-79.1 c-26.15-0.9-47.4,17.81-47.4,41.79V2219.6v355.54c0,23.98,21.25,42.21,47.4,40.74l2308.14-130.2 c20.04-1.13,36.25-19,36.25-39.92v-321.24V1037.39C3028.12,1016.47,3011.91,998.96,2991.87,998.27z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M683.72,2478.33c-10.18,0.5-18.47-6.69-18.47-16.01V961.88c0-9.33,8.29-16.65,18.47-16.31l2308.14,75.85 c7.82,0.26,14.17,7.11,14.17,15.27V2349.6c0,8.16-6.35,15.12-14.17,15.5L683.72,2478.33z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1435.77,1112.78c0-22.19-20.22-40.55-42.87-40.99l-521.84-10.26c-23.9-0.47-44.34,17.69-44.34,40.55 v511.96c0,22.87,19.47,41.23,43.37,41.01l522.77-4.85c22.65-0.21,42.9-18.38,42.9-40.58v-496.84L1435.77,1112.78L1435.77,1112.78 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2130.35,1125.19c0-21.41-15.17-39.11-36.25-39.52l-484.47-9.54c-22.2-0.44-40.42,17.07-40.42,39.11v493.41 c0,22.04,19.18,39.73,41.38,39.52l482.95-4.49c21.08-0.2,36.81-17.7,36.81-39.12V1125.19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1435.77,1831.64c0-22.19-20.22-39.87-42.87-39.5l-521.84,8.55c-23.9,0.39-44.34,19.26-44.34,42.13v511.96 c0,22.87,19.47,40.53,43.37,39.44l522.44-23.64c22.65-1.03,43.23-19.89,43.23-42.08v-496.86H1435.77z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2123.51,1818.91c0-21.42-15.12-38.53-36.21-38.18l-484.64,7.95c-22.22,0.36-40.29,18.54-40.29,40.59 v493.58c0,22.05,19.51,39.05,41.73,38.05l483.59-21.98c21.09-0.96,35.83-19.03,35.83-40.45v-479.56L2123.51,1818.91 L2123.51,1818.91z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2835.2,1188.41c0,18.57-14.22,33.43-31.82,33.2l-462.22-6.08c-18.53-0.24-32.88-15.93-32.88-35.02v-42.57 c0-19.1,14.37-34.29,32.9-33.94l462.53,8.79c17.6,0.33,31.5,15.66,31.5,34.23v41.39L2835.2,1188.41L2835.2,1188.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2624.29,1292.51c0,12.87-9.99,23.23-22.32,23.13l-272.03-2.17c-12.71-0.1-23.03-10.79-23.03-23.88l0,0 c0-13.09,10.32-23.59,23.03-23.46l272.03,2.84C2614.31,1269.1,2624.29,1279.64,2624.29,1292.51L2624.29,1292.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2624.29,1382.4c0,12.87-9.99,23.27-22.32,23.23l-272.03-0.86c-12.71-0.04-23.03-10.68-23.03-23.77l0,0 c0-13.09,10.32-23.64,23.03-23.57l272.03,1.54C2614.31,1359.04,2624.29,1369.53,2624.29,1382.4L2624.29,1382.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2624.29,1472.29c0,12.87-9.99,23.32-22.32,23.34l-272.03,0.45c-12.71,0.02-23.03-10.57-23.03-23.66l0,0 c0-13.09,10.32-23.69,23.03-23.68l272.03,0.23C2614.31,1448.98,2624.29,1459.42,2624.29,1472.29L2624.29,1472.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076587722054568376330000002839341782277356714_",
    gradientUnits: "userSpaceOnUse",
    x1: 1723.0297,
    y1: -1487.1124,
    x2: 1785.462,
    y2: -1487.1124,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076587722054568376330000002839341782277356714_)"
    },
    d: "M1726.89,1332.68 c-7.6,5.5-2.39,23.49,2.1,41.82c7.79,31.84,20.49,97.89,16.3,146.89c-0.45,5.23,3.75,9.68,9.01,9.56 c0.11,0,0.23-0.01,0.34-0.01c5.56-0.12,9.6-5.27,8.51-10.71c-3.88-19.26-15.21-47.2-9.57-70.46 c9.47-39.01,36.14-51.09,31.3-76.06C1779.42,1345.61,1738.52,1324.26,1726.89,1332.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147935093147552263240000015440291504247497627_",
    gradientUnits: "userSpaceOnUse",
    x1: 1852.1036,
    y1: -1601.0626,
    x2: 1851.0612,
    y2: -1435.2928,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147935093147552263240000015440291504247497627_)"
    },
    d: "M1980.41,1487.1 c-1.1-10.22-25.09-8.5-55.26-22.72c-26.23-12.36-29.49-23.73-51.06-46.88c-1.09-1.17-14.8-16.65-33.19-30.88 c-21.78-16.86-24.3-12.06-39.38-24.29c-28.84-23.39-27.1-46.96-56.55-61.41c-4.02-1.97-16.78-8.23-20.88-4.02 c-5.65,5.79,8.09,29.24,21.42,45.11c17.41,20.73,33.84,28.16,46.65,36.94c57.86,39.64,35.57,102.6,87.89,128.79 c28.29,14.17,57.18,6.88,63.74,5.03C1959.64,1508.3,1981.48,1497.09,1980.41,1487.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168087488458355381320000010052915055611360447_",
    gradientUnits: "userSpaceOnUse",
    x1: 1953.1641,
    y1: -1588.1615,
    x2: 1848.1398,
    y2: -1411.0311,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168087488458355381320000010052915055611360447_)"
    },
    d: "M1721.99,1292.71 c-3.67,1.83-3.64,12.33-3.59,33.33c0.04,15.39,0.25,23.08,2.54,28.35c6.88,15.87,23.15,13.23,50.38,28.65 c3.97,2.25,35.57,20.61,55.98,55.15c10.03,16.97,14.78,32.11,14.78,32.11c8.95,24.73,7.68,37.17,20.94,50.98 c8.64,9,22.63,16.18,107.89,17.24c77.07,0.96,115.37,1.43,118.32-10.71c3.86-15.9-53.06-42.76-74.99-51.77 c-22.04-9.05-33.07-13.58-45.89-11.33c-33.08,5.82-45.16,43.47-66.19,39.05c-6.05-1.27-8.98-5.21-19.58-18.96 c-14.21-18.41-29.89-35.75-43.04-55.02c-20.66-30.27-37.08-51.06-58.5-78.18C1733.52,1291.43,1724.92,1291.25,1721.99,1292.71z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035493884118697966200000002058494347970971528_",
    gradientUnits: "userSpaceOnUse",
    x1: 1953.1641,
    y1: -1588.1615,
    x2: 1848.1398,
    y2: -1411.0311,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035493884118697966200000002058494347970971528_)"
    },
    d: "M1721.99,1292.71 c-3.67,1.83-3.64,12.33-3.59,33.33c0.04,15.39,0.25,23.08,2.54,28.35c6.88,15.87,23.15,13.23,50.38,28.65 c3.97,2.25,35.57,20.61,55.98,55.15c10.03,16.97,14.78,32.11,14.78,32.11c8.95,24.73,7.68,37.17,20.94,50.98 c8.64,9,22.63,16.18,107.89,17.24c77.07,0.96,115.37,1.43,118.32-10.71c3.86-15.9-53.06-42.76-74.99-51.77 c-22.04-9.05-33.07-13.58-45.89-11.33c-33.08,5.82-45.16,43.47-66.19,39.05c-6.05-1.27-8.98-5.21-19.58-18.96 c-14.21-18.41-29.89-35.75-43.04-55.02c-20.66-30.27-37.08-51.06-58.5-78.18C1733.52,1291.43,1724.92,1291.25,1721.99,1292.71z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165915127851460419560000008286563401898672038_",
    gradientUnits: "userSpaceOnUse",
    x1: 1679.6938,
    y1: -1464.5111,
    x2: 1742.394,
    y2: -1464.5111,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165915127851460419560000008286563401898672038_)"
    },
    d: "M1683.57,1355.08 c-7.63,5.52-2.4,23.55,2.1,41.91c7.82,31.9,20.58,98.08,16.37,147.2c-0.45,5.24,3.77,9.7,9.05,9.57c0.12,0,0.23-0.01,0.35-0.01 c5.59-0.13,9.64-5.29,8.54-10.75c-3.89-19.3-15.28-47.29-9.61-70.6c9.51-39.11,36.3-51.24,31.44-76.26 C1736.33,1367.99,1695.25,1346.64,1683.57,1355.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064313652304862177130000005362153927841023405_",
    gradientUnits: "userSpaceOnUse",
    x1: 1809.3319,
    y1: -1578.7098,
    x2: 1808.2882,
    y2: -1412.7418,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064313652304862177130000005362153927841023405_)"
    },
    d: "M1938.2,1509.56 c-1.1-10.25-25.2-8.49-55.5-22.7c-26.35-12.36-29.62-23.75-51.28-46.92c-1.09-1.17-14.87-16.67-33.33-30.91 c-21.88-16.87-24.41-12.06-39.55-24.3c-28.97-23.41-27.22-47.03-56.8-61.48c-4.04-1.97-16.85-8.23-20.98-4.01 c-5.67,5.81,8.13,29.29,21.52,45.18c17.49,20.76,33.99,28.19,46.86,36.97c58.12,39.66,35.72,102.78,88.28,128.97 c28.42,14.16,57.43,6.83,64.02,4.97C1917.34,1530.83,1939.27,1519.56,1938.2,1509.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074435404321999183910000016534152144707824547_",
    gradientUnits: "userSpaceOnUse",
    x1: 1854.9835,
    y1: -1460.4183,
    x2: 1804.3127,
    y2: -1291.6896,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074435404321999183910000016534152144707824547_)"
    },
    d: "M1678.65,1315.03 c-3.68,1.84-3.66,12.36-3.6,33.41c0.04,15.42,0.26,23.14,2.55,28.41c6.91,15.9,23.25,13.23,50.6,28.65 c3.99,2.25,35.73,20.62,56.23,55.21c10.07,17,14.84,32.17,14.84,32.17c8.99,24.78,7.72,37.24,21.03,51.07 c8.67,9.01,22.73,16.19,108.37,17.15c77.4,0.87,115.87,1.3,118.84-10.87c3.88-15.94-53.29-42.79-75.31-51.8 c-22.13-9.04-33.22-13.57-46.09-11.3c-33.22,5.87-45.36,43.62-66.47,39.21c-6.07-1.27-9.02-5.21-19.67-18.98 c-14.27-18.43-30.02-35.8-43.23-55.09c-20.75-30.31-37.25-51.13-58.76-78.28C1690.23,1313.74,1681.59,1313.56,1678.65,1315.03z "
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1394.71,1141.39c0,10.56-9.96,19-20.74,18.83l-111.79-1.68c-10.91-0.17-21.44-8.93-21.44-19.57v-0.78 c0-10.64,9.9-19.12,20.82-18.93l111.89,1.89c10.78,0.19,21.27,8.9,21.27,19.46v0.78L1394.71,1141.39L1394.71,1141.39z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2072.18,1152.5c0,10.2-5.77,18.34-15.83,18.19l-100.94-1.57c-10.17-0.16-16.68-8.61-16.68-18.89v-0.76 c0-10.27,7.7-18.46,17.87-18.29l100.02,1.77c10.06,0.17,15.55,8.59,15.55,18.79v0.76H2072.18z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1394.71,1851.02c0,10.56-9.96,19.33-20.74,19.55l-111.79,2.25c-10.91,0.22-21.44-8.21-21.44-18.85v-0.78 c0-10.64,9.9-19.43,20.82-19.64l111.89-2.05c10.78-0.2,21.27,8.18,21.27,18.74v0.78H1394.71z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2072.18,1879.06c0,10.2-9.15,18.67-19.21,18.9l-102.69,2.31c-10.18,0.23-18.38-7.91-18.38-18.19v-0.76 c0-10.28,7.7-18.78,17.88-18.99l103.47-2.12c10.06-0.21,18.93,7.89,18.93,18.09V1879.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046341230181193072940000008321472399482824883_",
    gradientUnits: "userSpaceOnUse",
    x1: 1231.6124,
    y1: -1699.9586,
    x2: 993.0942,
    y2: -1280.556,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046341230181193072940000008321472399482824883_)"
    },
    d: "M1040.18,1184.61l28.51-5.62 c0,0,28.13,25.46,58.37,23.33c30.15-2.12,61.5-20.83,67.25-19.83c2.98,0.52,6.8-0.22,9.72,1.81c5.39,3.74,4.66,12.58,4.46,15.95 c-2.37,39.81,8.27,47.19-1.81,76.09c-8.04,23.05-22.05,39.16-32.78,49.05c16.87,11.32,37.2,28.45,53.78,53.56 c52.41,79.41,22.21,171.02,16.86,186.4c-17.37-3.52-43.76-7.31-75.78-5.54c-42.55,2.36-59.33,12.56-90.66,13.34 c-24.42,0.6-59.62-4.47-103.3-31.76c0.82-34.12,8.02-114.35,68.94-179.54c14.42-15.43,29.55-27.54,43.88-37.05 c-27.22-19.03-36.39-38.63-40.01-49.94c-1.39-4.35-2.9-10.43-4.86-36.17C1041.04,1216.19,1040.42,1197.57,1040.18,1184.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147932156505230445320000007750311455392108211_",
    gradientUnits: "userSpaceOnUse",
    x1: 1237.611,
    y1: -1696.6711,
    x2: 1002.5233,
    y2: -1283.3007,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000147932156505230445320000007750311455392108211_)",
      enableBackground: "new"
    },
    d: " M1227.68,1378.95c-16.57-25.11-36.91-42.24-53.78-53.56c10.73-9.88,24.74-26,32.78-49.05c3.72-10.67,4.62-18.41,4.39-25.92 c-15.38,13.43-34.41,22.5-55.22,25.63c-4.74,0.71-51.38,6.97-87.8-24.71c-11.83-10.29-20.87-23.11-26.86-37.38 c0.38,7.57,0.88,15.84,1.56,24.72c1.96,25.74,3.47,31.83,4.86,36.17c3.61,11.31,12.79,30.91,40.01,49.94 c-10.81,7.18-22.08,15.84-33.15,26.29c18.56,2.93,31.08,9.57,39.85,16.86c35.59,29.57,28.07,85.3,60,93.96 c22.12,6,36.29-17.96,55.07-13.34c16.4,4.03,32.27,28.89,37.78,108.71C1255.69,1529.3,1274.15,1449.37,1227.68,1378.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010294629267919630230000000725843180403025566_",
    gradientUnits: "userSpaceOnUse",
    x1: 1138.5775,
    y1: -1678.4635,
    x2: 1128.9272,
    y2: -1582.9254,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010294629267919630230000000725843180403025566_)"
    },
    d: "M1079.87,1317.41l0.35,10.85 c0,0,69.3,12.97,100.01,2.25l-0.16-9.6C1180.06,1320.91,1091.51,1323.87,1079.87,1317.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080926990121584072380000017461622790896123051_",
    gradientUnits: "userSpaceOnUse",
    x1: 935.4317,
    y1: -725.0798,
    x2: 1319.7521,
    y2: -725.0798,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080926990121584072380000017461622790896123051_)"
    },
    d: "M1312.07,2167.36 c-13.87-93.36-136.09-94.29-182.65-91.21c-46.77-0.26-171.65,8.18-186.01,104.13c-9.63,64.32-8.91,97.48-6.24,114.08 c1.54,9.56,10.14,16.55,20.28,16.13l167.27-6.94l9.39-0.39l164.4-6.82c9.79-0.41,18.08-7.96,19.57-17.47 C1320.65,2262.39,1321.34,2229.81,1312.07,2167.36z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006670426556545075290000013633822507839083938_",
    gradientUnits: "userSpaceOnUse",
    x1: 1022.0655,
    y1: -794.3331,
    x2: 1138.08,
    y2: -794.3331,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006670426556545075290000013633822507839083938_)"
    },
    d: "M1062.51,2305.29 c0,0-33.92-350.06,75.57-352.62v-11.93c0,0-43.57-10.3-86.99,58.58c-43.61,69.17-25.14,307.82-25.14,307.82L1062.51,2305.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075883115001673360270000007718758103064892328_",
    gradientUnits: "userSpaceOnUse",
    x1: 6079.5273,
    y1: -798.1335,
    x2: 6192.8296,
    y2: -798.1335,
    gradientTransform: "matrix(-1 0 0 1 7317.2295 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075883115001673360270000007718758103064892328_)"
    },
    d: "M1197.97,2299.62 c0,0,35.92-349.37-73.57-346.69V1941c0,0,41.9-12.23,84.83,54.13c42.75,66.07,24.68,303.34,24.68,303.34L1197.97,2299.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165937913681691150060000004122885795559075725_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.2306,
    y1: -857.5671,
    x2: 1105.3724,
    y2: -580.8107,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165937913681691150060000004122885795559075725_)"
    },
    d: "M1175.72,2102.25 c0,24.84-22.23,45.72-47.92,46.59l-4.01,0.15c-25.77,0.87-47.3-18.63-47.3-43.59v-14.13c0-24.96,20.8-45.81,46.57-46.55 l4.81-0.14c25.69-0.74,47.85,18.77,47.85,43.61L1175.72,2102.25L1175.72,2102.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047024044111057829470000000950770913439078816_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.2306,
    y1: -857.5671,
    x2: 1105.3724,
    y2: -580.8107,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000047024044111057829470000000950770913439078816_)",
      enableBackground: "new"
    },
    d: " M1175.72,2102.25c0,24.84-22.23,45.72-47.92,46.59l-4.01,0.15c-25.77,0.87-47.3-18.63-47.3-43.59v-14.13 c0-24.96,20.8-45.81,46.57-46.55l4.81-0.14c25.69-0.74,47.85,18.77,47.85,43.61L1175.72,2102.25L1175.72,2102.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069371629569833617330000003259576759723126169_",
    gradientUnits: "userSpaceOnUse",
    x1: 1130.1058,
    y1: -799.1855,
    x2: 1124.8132,
    y2: -737.7912,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069371629569833617330000003259576759723126169_)"
    },
    d: "M1141.4,2126.49 c0,6.41-5.36,11.78-11.98,12s-12-4.8-12-11.21s5.37-11.79,12-12C1136.04,2115.07,1141.4,2120.09,1141.4,2126.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026129596360732930780000007001953414800929957_",
    gradientUnits: "userSpaceOnUse",
    x1: 1705.7,
    y1: -788.0391,
    x2: 2023.84,
    y2: -788.0391,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026129596360732930780000007001953414800929957_)"
    },
    d: "M2023.84,2237.22 c0,0-34.69-106.46-33.72-165.25c0.97-58.78-60.09-108.36-60.09-108.36l-52.88,1.03v-0.15l-10.22,0.34l-10.31,0.19v0.15 l-55.18,1.74c0,0-63.41,53.45-62.42,112.93s-33.32,170.1-33.32,170.1s41.42,44.89,150.91,45.84v0.53 c0,0.03,6.45-0.28,10.32-0.53c3.83-0.08,6.79-0.17,10.21-0.35v-0.52C1979.8,2285.11,2023.84,2237.22,2023.84,2237.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096738093137085944500000004120453921094420653_",
    gradientUnits: "userSpaceOnUse",
    x1: 1774.5,
    y1: -955.0801,
    x2: 1952.4301,
    y2: -955.0801,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000096738093137085944500000004120453921094420653_)"
    },
    points: "1952.43,1979.56  1774.5,1984.22 1774.5,1945.94 1952.43,1941.62  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017479118751140902940000013394548939943025553_",
    gradientUnits: "userSpaceOnUse",
    x1: 1818.98,
    y1: -955.0446,
    x2: 1901.1,
    y2: -955.0446,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0985,
    style: {
      stopColor: "#FEBC46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017479118751140902940000013394548939943025553_)"
    },
    d: "M1901.1,1977.19 c0,7.79-6.88,14.28-14.63,14.49l-52.28,1.38c-7.8,0.21-15.21-5.96-15.21-13.79v-30.69c0-7.82,7.11-14.32,14.91-14.5 l52.19-1.23c7.75-0.19,15.02,5.98,15.02,13.77V1977.19z M1894.26,1946.98c0-2.17-2.36-3.88-4.52-3.83l-50.26,1.25 c-2.17,0.05-3.39,1.86-3.39,4.03v26.82c0,2.18,0.91,3.89,3.08,3.84l50.99-1.34c2.16-0.06,4.1-1.86,4.1-4.03L1894.26,1946.98 L1894.26,1946.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114787684797674164780000017318554610485815220_",
    gradientUnits: "userSpaceOnUse",
    x1: 1873.7301,
    y1: -952.2401,
    x2: 1897.6801,
    y2: -952.2401,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0985,
    style: {
      stopColor: "#FEBC46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114787684797674164780000017318554610485815220_)"
    },
    d: "M1897.68,1967.24 c0,1.88-2.12,3.44-3.98,3.48l-16.96,0.45c-1.87,0.05-3.01-1.43-3.01-3.31v-3.59c0-1.88,0.84-3.44,2.71-3.48l17.6-0.44 c1.86-0.05,3.64,1.43,3.64,3.31V1967.24z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097498937332594686700000010022376669109588646_",
    gradientUnits: "userSpaceOnUse",
    x1: 6878.377,
    y1: 114.6636,
    x2: 6897.4199,
    y2: 357.0312,
    gradientTransform: "matrix(-1 0 0 1 8192.6523 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097498937332594686700000010022376669109588646_)"
    },
    d: "M1277.13,3153.54 c0,0,76.66,34.84,77.91,40.4c1.25,5.56-49.3-1.86-69.93-1.06c-20.64,0.8-37.61-5.3-35.74-14.04s9.09-30.73,9.09-30.73 L1277.13,3153.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027588016869687982960000001873681096892937350_",
    gradientUnits: "userSpaceOnUse",
    x1: 6927.5498,
    y1: 249.5978,
    x2: 6924.0874,
    y2: -1.4193,
    gradientTransform: "matrix(-1 0 0 1 8192.6523 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027588016869687982960000001873681096892937350_)"
    },
    d: "M1279.93,3125.26l-4.66,34.51 c0,0-12.14,4.32-20.29-0.79l-3.48-37.85L1279.93,3125.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060008237172749458320000010218984762743593911_",
    gradientUnits: "userSpaceOnUse",
    x1: 7238.2578,
    y1: 86.389,
    x2: 7257.3008,
    y2: 328.7537,
    gradientTransform: "matrix(-1 0 0 1 8192.6523 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060008237172749458320000010218984762743593911_)"
    },
    d: "M918.93,3126.09l-8.92,14.31 c-2.49,4-3.24,8.82-2.04,13.38c3.12,11.9,9.34,35.1,12.06,41.15c3.7,8.24,53.31,13.13,53.31,13.13s4.42-6.23-5.88-13.74 c-10.3-7.52-16.92-8.7-20.55-19.8c-3.63-11.09-6.06-42.48-6.06-42.48L918.93,3126.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107560682630239970860000011038966933589853628_",
    gradientUnits: "userSpaceOnUse",
    x1: 7257.3433,
    y1: 245.0486,
    x2: 7253.8809,
    y2: -5.9729,
    gradientTransform: "matrix(-1 0 0 1 8192.6523 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107560682630239970860000011038966933589853628_)"
    },
    d: "M956.05,3089.72 c-3.26,2.6-19.19,50.95-19.19,50.95s-5.16,6.59-14.95-3.14c-9.8-9.73-4.43-4.37-4.43-4.37l1.84-47.56L956.05,3089.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183943212993398762320000013684994332446719135_",
    gradientUnits: "userSpaceOnUse",
    x1: 6241.3784,
    y1: -157.0478,
    x2: 6426.9639,
    y2: -157.0478,
    gradientTransform: "matrix(-1 0 0 1 7566.3896 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183943212993398762320000013684994332446719135_)"
    },
    d: "M1322.11,2431.87 c4.04,102.95,4.21,214.8-1.72,334.3c-6.67,134.56-20.07,258.93-36.96,371.66c-6.28,0.2-12.88,0.23-19.77,0.04 c-4.65-0.13-9.16-0.36-13.52-0.66c-8.77-23.38-19.13-54.12-28.4-90.84c-9.75-38.61-15.64-73.24-19.83-106.36 c-14.76-116.61,2.54-126.78-9.44-213.2c-10.61-76.54-25.7-79.52-43.41-188.19c-19.22-117.91-4.91-135.59,2.05-141.98 C1180.71,2369.44,1250.28,2387.96,1322.11,2431.87z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127747944501762050780000000421351190519844027_",
    gradientUnits: "userSpaceOnUse",
    x1: 6254.21,
    y1: -157.0425,
    x2: 6426.9688,
    y2: -157.0425,
    gradientTransform: "matrix(-1 0 0 1 7566.3896 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    style: {
      stopColor: "#26264F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#444B8C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000127747944501762050780000000421351190519844027_)",
      enableBackground: "new"
    },
    d: " M1151.1,2396.64c28.25-25.95,92.85-10.24,161.08,29.36c-78.5,84.81-87.05,139.82-77.64,175.52 c10.64,40.34,42.97,51.96,42.85,96.08c-0.15,54.21-49.08,68.57-48.04,125.94c0.69,37.93,22.19,37.54,27.27,84.39 c6.01,55.44-22.08,74.54-12.98,115.56c3.91,17.65,15.09,40.7,46.9,64.46c-2.29,16.84-4.65,33.52-7.1,49.88 c-6.28,0.2-12.88,0.23-19.77,0.04c-4.65-0.13-9.16-0.35-13.52-0.66c-8.77-23.38-19.13-54.12-28.4-90.84 c-9.75-38.61-15.64-73.24-19.83-106.36c-14.76-116.61,2.54-126.78-9.44-213.2c-10.61-76.54-25.7-79.53-43.41-188.19 C1129.83,2420.72,1144.14,2403.03,1151.1,2396.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040537108132819449530000012425028410246117793_",
    gradientUnits: "userSpaceOnUse",
    x1: 6292.8994,
    y1: -175.3333,
    x2: 6666.5327,
    y2: -175.3333,
    gradientTransform: "matrix(-1 0 0 1 7566.3896 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040537108132819449530000012425028410246117793_)"
    },
    d: "M1273.49,2430.14 c-67.59,98.9-140.49,221.97-205.68,369.3c-49.27,111.33-85,215.86-111.24,309.02c-3.55,1.64-11.92,4.92-22.63,3.51 c-14.6-1.93-23.34-11.25-25.63-13.85c-10.68-66.78-9.5-123.34-5.88-164.16c2.32-26.14,6.43-69.66,23.09-123.39 c18.66-60.19,31.49-63.57,55.83-127.24c25.27-66.09,19.15-82.58,43.34-165.29c9.94-33.98,26.58-84.54,54.04-145.02 C1143.65,2392.05,1208.57,2411.1,1273.49,2430.14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122703658099701079760000012925621612152178360_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.6272,
    y1: -1223.5369,
    x2: 358.1627,
    y2: -916.1421,
    gradientTransform: "matrix(0.9998 0.0218 -0.0218 0.9998 1160.7581 2850.5698)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122703658099701079760000012925621612152178360_)"
    },
    d: "M1593.17,1726.17 c0,0,13.11-15.7,21.47-27.39c8.36-11.7,46.9-44.22,46.9-44.22s2.77,5.36-5.56,13.65c-8.32,8.29-25.77,22.43-21.97,28.66 c3.81,6.23,14.77,11.88,6.52,23.3c-8.26,11.42-22,3.2-29.31,12.34c-7.32,9.14-14.82,19.13-14.82,19.13L1593.17,1726.17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044874510691186306360000003451445325018102696_",
    gradientUnits: "userSpaceOnUse",
    x1: 6172.5366,
    y1: -961.0259,
    x2: 6347.7979,
    y2: -234.3626,
    gradientTransform: "matrix(-0.9998 -0.0218 -0.0218 0.9998 7533.8677 2989.4866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044874510691186306360000003451445325018102696_)"
    },
    d: "M1591.33,1709.68 c8.75,10.98,17.5,21.96,26.25,32.94c-11.19,48.41-35.04,121.36-90.5,192.22c-58.78,75.11-184.16,187.59-262.2,150.71 c-47.57-22.48-111.8-99.6-88.72-136.79c22.19-35.75,118.2-18.85,184.14-33.74C1424.93,1900.42,1508.82,1853.38,1591.33,1709.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165937151637885719640000016851444686394686391_",
    gradientUnits: "userSpaceOnUse",
    x1: 6437.2485,
    y1: -717.0542,
    x2: 6581.5488,
    y2: -717.0542,
    gradientTransform: "matrix(-0.9998 -0.0218 -0.0218 0.9998 7533.8677 2989.4866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165937151637885719640000016851444686394686391_)"
    },
    d: "M998.16,1995.4 c0,0-51.14,174.07-19.46,241.04c31.68,66.98,132.71-6.58,132.71-6.58L998.16,1995.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137813154138386501630000006224405806177272503_",
    gradientUnits: "userSpaceOnUse",
    x1: 6318.4517,
    y1: -996.2184,
    x2: 6493.7129,
    y2: -269.5566,
    gradientTransform: "matrix(-0.9998 -0.0218 -0.0218 0.9998 7533.8677 2989.4866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137813154138386501630000006224405806177272503_)"
    },
    d: "M1147.73,1930.83 c65.69-1.19,116.29,0.95,144.26,30.15c29.54,30.84-1.72,64.25,3.12,143.34c7.4,121.09,83.78,152.3,86.9,275.04 c1.05,41.36-6.67,74.98-12.55,95.2c-17.36,20.68-45.68,49.79-87.05,73.74c-60.2,34.85-94.52,27.8-180.36,49.29 c-140.41,35.16-153.82,80.38-222.77,67.28c-69.69-13.24-129.77-73.44-121.66-105.6c4.86-19.26,32.94-13.16,66.05-41.98 c42.67-37.14,27.33-73.81,60.03-114.01c46.97-57.74,109.85-20.45,149.89-70.5c40.51-50.64,27.1-152.45-4.9-208.48 c-20.9-36.6-29.26-79.14-46.89-117.42c-1.46-3.18-3.13-8.38-2.21-14.81c3.53-24.6,44.95-37.09,76.31-46.23 C1103.73,1931.89,1142.33,1930.92,1147.73,1930.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122719415101576242560000005579727169275171495_",
    gradientUnits: "userSpaceOnUse",
    x1: 5109.791,
    y1: -975.3563,
    x2: 5166.7866,
    y2: -884.7658,
    gradientTransform: "matrix(-0.9998 -0.0218 -0.0218 0.9998 6284.6016 2962.2515)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122719415101576242560000005579727169275171495_)"
    },
    d: "M1211.68,1929.51l-12.86-4.27 c0,0-3.77,17.45-45.44,18.73c-23.1-0.5-37.76-13.77-37.76-13.77l-8.99,6.26c0,0,18.88,24.66,49.75,24.72 C1196.24,1961.25,1211.68,1929.51,1211.68,1929.51z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155862238803896596480000003282768338473168819_",
    gradientUnits: "userSpaceOnUse",
    x1: 6648.9985,
    y1: 139.9618,
    x2: 6582.2822,
    y2: 247.8852,
    gradientTransform: "matrix(-0.9519 -0.3063 -0.3063 0.9519 7522.3179 3747.1714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155862238803896596480000003282768338473168819_)"
    },
    d: "M1201.13,1873.16 c3.52-19.09-7.19-35.5-9.54-39.03c-9.85-14.78-12.2-16.71-16.47-19.03l-5.91-2.94c0,0-0.34-0.1-0.69-0.19 c-3.7-0.95-15.97-0.2-18.4,0.55c-7.76,2.41-13.24,35.42-6.67,80.79c-0.31,3.56-0.63,7.12-0.94,10.68 c-17.66-2.44-22.78-0.76-23.68,1.61c-1.96,5.12,10.34,35.06,27.16,40.95c21.1,7.39,50.49-11.88,52.26-18.85 c0.71-2.82,0.59-0.4-13.78-8.72c-1.32-4.17-5.43-15.47-6.75-19.64C1180.77,1897.38,1198.54,1887.22,1201.13,1873.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018210093480569236450000017246278016488134807_",
    gradientUnits: "userSpaceOnUse",
    x1: 6372.1992,
    y1: 265.0532,
    x2: 6311.5776,
    y2: 363.1175,
    gradientTransform: "matrix(-0.8526 -0.5224 -0.5224 0.8526 6747.0132 4938.6221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018210093480569236450000017246278016488134807_)"
    },
    d: "M1177.06,1857.79 c-3.9-4.44-9.57,0.58-9.04,6.74c0.53,6.16,7.07,12.01,12.75,10.27C1186.43,1873.06,1182.3,1863.77,1177.06,1857.79z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M551.68,1656.42c85.69-48.48,227.39,17.98,291.55,99.71c29.81,37.98,39.58,74.65,83.76,91.69 c33.59,12.95,92.16,17.6,132.75-10.24c5.11-3.51,25.86-18.44,55.5-36.16c13.07-7.81,25.86-14.97,41.35-12.53 c3.93,0.62,17.04,2.6,22.69,13.29c4.58,8.67,2.56,20.53-2.04,28.06c-2.75,4.5-4.45,4.53-5.26,7.8 c-2.28,9.18,12.83,18.36,10.46,22.59c-1.69,3.02-9.83-0.9-12.6,2.69c-3.04,3.93,5.08,10.77,5.5,23.25 c5.91,7.46,6.63,21.54,2.87,38.85c-5.52,25.45-14.45,44.7-23.99,58.3c-45.91,65.45-78.74,112.27-127.05,128.77 c-63.96,21.84-98.99-28.61-228.42-76.46c-177.22-65.52-241.63-19.03-292.81-81.48C442.04,1876.57,462.71,1706.76,551.68,1656.42 z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st47"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159461394666400533070000013482276521998612660_",
    gradientUnits: "userSpaceOnUse",
    x1: 6277.3477,
    y1: -986.3043,
    x2: 6452.6089,
    y2: -259.6419,
    gradientTransform: "matrix(-0.9998 -0.0218 -0.0218 0.9998 7533.8677 2989.4866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159461394666400533070000013482276521998612660_)"
    },
    d: "M928.62,2560.93 c66.06-43.9,125.87,6.32,172.57-32.36c38.46-31.85,6.92-73.37,48.54-129.43c45.63-61.46,108.95-45.75,124.04-91.68 c15.6-47.47-46.97-79.69-48.54-145.61c-0.8-33.64,14.31-77.45,74.64-130c-3.26,19.18-6.59,42.55-4.76,72.46 c7.41,121.09,83.78,152.3,86.9,275.04c1.05,41.36-6.67,74.98-12.55,95.2c-17.36,20.68-45.68,49.79-87.05,73.74 c-60.2,34.85-94.52,27.8-180.36,49.29c-140.41,35.16-153.82,80.38-222.77,67.28c-20.09-3.82-39.36-11.54-56.45-21.37 c20.08-3.13,35.05-9.96,46.47-17.86C899.47,2604.76,894.17,2583.82,928.62,2560.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114795188613980274060000009713928616524517557_",
    d: "M2157.31,602.37 c761.82,0,848.02,650.76,848.02,650.76h218.5v59.13l-429.52,590.72l-524.83-685.74h206.72l-292.53-342.9 c0,0-249.86,51.63-372.25,50.2c-160.97-1.89-292.12-10.6-292.12-10.6S1580.69,602.37,2157.31,602.37z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151511520208118531150000012622205583686026398_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114795188613980274060000009713928616524517557_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000151511520208118531150000012622205583686026398_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153679963088451527090000015116354505774491264_",
    gradientUnits: "userSpaceOnUse",
    x1: 5381.897,
    y1: -695.009,
    x2: 6364.4888,
    y2: -1881.3625,
    gradientTransform: "matrix(-1 0 0 1 8497.2393 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153679963088451527090000015116354505774491264_)"
    },
    d: "M1479.67,1269.02v2.47 c22.73-29.56,63.45-70.61,87.83-94.39c0.46-1.05,1.22-2.1,1.67-3.15c13.6-31.07,31.96-64.71,55.92-98.29 c23.8-33.67,54.05-66.81,89.31-97.33c4.22-3.96,9.1-7.45,13.62-11.19c2.31-1.82,4.63-3.71,6.97-5.53l3.42-2.78 c1.2-0.93,2.44-1.76,3.64-2.66c4.84-3.49,9.68-7.02,14.55-10.57l3.64-2.66l3.83-2.47c2.53-1.67,5.07-3.34,7.6-4.98 c10-6.89,20.78-12.86,31.3-19.17c5.36-3.06,10.98-5.87,16.43-8.78c2.7-1.45,5.46-2.94,8.22-4.36 c2.83-1.33,5.68-2.69,8.47-4.02c45.07-21.67,94.23-37.35,144.66-45.97c6.3-0.99,12.6-1.98,18.96-2.97 c6.33-0.83,12.76-1.36,19.06-2.07l9.54-1.02l9.58-0.49l9.58-0.56c3.18-0.15,6.33-0.46,9.55-0.4 c6.36-0.03,12.73-0.09,19.13-0.12c1.56,0,3.25-0.09,4.71,0l4.25,0.22l8.51,0.43l8.44,0.4c0.75,0.03,1.27,0.03,2.24,0.09 l8.67,0.62l11.59,0.77l8.67,0.62l1.46,0.09l0.52,0.03c0,0.03,3.02,0-2.05,0.09l18.74,2.63c3.08,0.46,6.2,0.74,9.29,1.39 l9.19,1.76l9.19,1.73l4.58,0.87c1.53,0.28,3.02,0.71,4.51,1.05c6.01,1.45,12.01,2.88,17.99,4.36 c3.02,0.62,5.94,1.61,8.86,2.44l8.77,2.63l8.77,2.5l8.57,3c5.71,2.04,11.43,3.83,16.98,6c5.52,2.23,11.07,4.45,16.56,6.71 c43.67,18.49,82.93,42.39,116.34,69.69l6.3,5.01l5.98,5.35c3.96,3.52,8.05,6.89,11.82,10.51c0.16,0.12,0.29,0.31,0.45,0.43 c7.34,7.23,14.78,14.04,21.37,21.52c1.75,1.82,3.48,3.68,5.16,5.53l2.6,2.72l2.4,2.91c3.22,3.77,6.4,7.57,9.58,11.32 c0.78,0.93,1.62,1.82,2.4,2.78l2.18,2.91c1.49,1.95,2.95,3.9,4.42,5.78c2.86,3.9,5.97,7.48,8.54,11.5 c21.69,30.92,38.22,61.83,49.45,91.33c11.33,29.43,18.05,57.04,21.92,81.44c0.42,3.06,0.85,6.06,1.27,9.03 c0.36,2.94,0.97,5.81,1.1,8.69c0.49,5.75,0.98,11.22,1.46,16.45c0.32,5.32,0.32,10.42,0.55,15.21 c0.1,2.41,0.26,4.76,0.29,7.02c-0.1,2.32-0.16,4.58-0.2,6.74c-0.06,4.36-0.13,8.47-0.19,12.3c0.03,1.08-0.16,1.64-0.23,2.38 c-0.1,0.71-0.2,1.42-0.29,2.1c-0.13,1.36-0.32,1.17-0.45,2.41c-0.1,1.05-0.23,1.55-0.32,1.55H2335.3l129.88,137.12 l301.94,314.43l431.86-451.54h-227.07c-0.33,0-0.68-3.71-1.04-6.62c-0.88-6.28-1.82-12.4-2.86-19.85 c-0.58-3.71-1.1-7.17-1.72-11.16c-0.32-1.95-0.62-3.8-0.94-5.84c-0.29-2.01-0.58-4.17-1-5.94c-1.59-7.48-3.25-15.37-5-23.78 c-0.94-4.17-1.85-8.44-2.83-12.83c-1.04-4.39-2.27-8.84-3.51-13.42c-2.47-9.12-4.87-18.7-7.86-28.57 c-3.18-9.8-6.49-19.97-9.9-30.55c-1.66-5.32-3.83-10.54-5.85-15.95c-2.05-5.32-4.16-10.79-6.3-16.36 c-17.63-44.06-41.69-92.04-73.87-140.27c-32.05-48.26-72.86-96.34-121.31-140.92c-5.88-5.72-12.37-10.94-18.64-16.42 c-3.18-2.69-6.33-5.41-9.51-8.13l-4.84-4.08l-4.94-3.9c-6.66-5.16-13.38-10.39-20.07-15.61l-5.07-3.9l-5.26-3.71 c-3.54-2.5-7.05-4.98-10.59-7.45c-13.86-10.11-28.77-19.23-43.58-28.63c-7.47-4.58-15.2-8.84-22.89-13.26 c-3.8-2.16-7.66-4.33-11.53-6.55c-3.96-2.04-7.92-4.08-11.88-6.12c-63.19-32.96-133-57.97-205.47-72.93 c-9.06-1.7-18.18-3.43-27.27-5.13c-9.09-1.61-18.35-2.72-27.5-4.05l-13.77-1.85l-13.86-1.3l-13.83-1.27 c-4.61-0.4-9.19-0.9-13.83-1.05c-9.22-0.4-18.48-1.45-27.73-1.85c-2.27-0.09-4.61-0.93-6.92-0.93h-6.95l-13.8,0.74l-13.8,0.43 c-4.61,0-9.22,0.59-13.8,0.8l-27.44,1.58c-6.23,0.09-2.14,0.15-3.73,0.19l-0.71,0.09l-1.46,0.15l-2.86,0.37l-5.78,0.68 l-11.49,1.36l-5.78,0.68l-2.86,0.34l-3.54,0.46l-14.55,2.04l-14.55,2.1l-7.21,1.08c-2.37,0.37-4.48,0.87-6.75,1.3 c-8.86,1.79-17.73,3.62-26.59,5.38c-4.42,0.83-8.77,2.04-13.12,3.12l-13.09,3.31l-12.99,3.31l-12.82,3.86 c-8.51,2.63-17.05,5.1-25.39,7.95c-8.35,2.97-16.63,5.94-24.9,8.9c-65.69,24.86-125.63,58.03-177.16,96.65 c-3.25,2.38-6.46,4.79-9.67,7.17c-3.15,2.47-6.24,4.98-9.32,7.51c-6.17,5.01-12.37,9.83-18.31,14.96 c-11.72,10.48-23.41,20.53-34.09,31.41c-2.73,2.66-5.39,5.35-8.12,7.98l-3.99,3.96l-3.83,4.11 c-5.1,5.5-10.13,10.98-15.1,16.39l-3.73,4.08l-3.57,4.2c-2.31,2.81-4.68,5.6-6.98,8.38c-4.61,5.6-9.45,10.91-13.61,16.7 c-23.54,30.27-43.48,60.94-59.97,91.17c-8.05,14.69-15.23,29.31-21.56,43.75c-19.58,44.09-32.15,86.04-40.07,123.42 c-0.88,4.7-1.82,9.31-2.7,13.85c-0.84,4.51-1.85,8.94-2.4,13.36c-1.23,8.81-2.47,17.25-3.6,25.38 c-0.98,8.16-1.49,16.02-2.21,23.47c-0.29,3.71-0.68,7.33-0.91,10.91c-0.13,3.52-0.91,6.99-1.07,10.39 C1480.81,1256.59,1479.67,1263.05,1479.67,1269.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062191401707260010150000005140232278145959555_",
    gradientUnits: "userSpaceOnUse",
    x1: 6456.8315,
    y1: -1666.9287,
    x2: 6761.3535,
    y2: -2084.2764,
    gradientTransform: "matrix(-1 0 0 1 8497.2393 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000062191401707260010150000005140232278145959555_)",
      enableBackground: "new"
    },
    d: " M1479.67,1269.02v2.47c22.73-29.56,63.45-70.61,87.83-94.39c0.46-1.05,1.22-2.1,1.67-3.15c13.6-31.07,31.96-64.71,55.92-98.29 c23.8-33.67,54.05-66.81,89.31-97.33c4.22-3.96,9.1-7.45,13.62-11.19c2.31-1.82,4.63-3.71,6.97-5.53l3.42-2.78 c1.2-0.93,2.44-1.76,3.64-2.66c4.84-3.49,9.68-7.02,14.55-10.57l3.64-2.66l3.83-2.47c2.53-1.67,5.07-3.34,7.6-4.98 c10-6.89,20.78-12.86,31.3-19.17c5.36-3.06,10.98-5.87,16.43-8.78c2.7-1.45,5.46-2.94,8.22-4.36 c2.83-1.33,5.68-2.69,8.47-4.02c45.07-21.67,94.23-37.35,144.66-45.97c6.3-0.99,12.6-1.98,18.96-2.97 c6.33-0.83,12.76-1.36,19.06-2.07l9.54-1.02l9.58-0.49l9.58-0.56c3.18-0.15,6.33-0.46,9.55-0.4 c6.36-0.03,12.73-0.09,19.13-0.12c1.56,0,3.25-0.09,4.71,0l4.25,0.22l8.51,0.43l8.44,0.4c0.75,0.03,1.27,0.03,2.24,0.09 l8.67,0.62l11.59,0.77l8.67,0.62l1.46,0.09l0.52,0.03c0,0.03,3.02,0-2.05,0.09l18.74,2.63c3.08,0.46,6.2,0.74,9.29,1.39 l9.19,1.76l9.19,1.73l4.58,0.87c1.53,0.28,3.02,0.71,4.51,1.05c6.01,1.45,12.01,2.88,17.99,4.36 c3.02,0.62,5.94,1.61,8.86,2.44l8.77,2.63l8.77,2.5l8.57,3c5.71,2.04,11.43,3.83,16.98,6c5.52,2.23,11.07,4.45,16.56,6.71 c43.67,18.49,82.93,42.39,116.34,69.69l6.3,5.01l5.98,5.35c3.96,3.52,8.05,6.89,11.82,10.51c0.16,0.12,0.29,0.31,0.45,0.43 c-95.95-113.13-251.39-186.61-426.79-186.61c-179.72,0-338.47,77.14-433.74,194.96c-8.05,14.69-15.23,29.31-21.56,43.75 c-19.58,44.09-32.15,86.04-40.07,123.42c-0.88,4.7-1.82,9.31-2.7,13.85c-0.84,4.51-1.85,8.94-2.4,13.36 c-1.23,8.81-2.47,17.25-3.6,25.38c-0.98,8.16-1.49,16.02-2.21,23.47c-0.29,3.71-0.68,7.33-0.91,10.91 c-0.13,3.52-0.91,6.99-1.07,10.39C1480.81,1256.59,1479.67,1263.05,1479.67,1269.02z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029037556424025707520000013200581906235703428_",
    gradientUnits: "userSpaceOnUse",
    x1: 2947.3621,
    y1: -678.3663,
    x2: 2149.0562,
    y2: -305.6706,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000029037556424025707520000013200581906235703428_)"
    },
    cx: 2683.35,
    cy: 2362.89,
    r: 548.99
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074432986789606959180000003336616376124795304_",
    gradientUnits: "userSpaceOnUse",
    x1: 1987.1998,
    y1: -1280.8578,
    x2: 3059.2778,
    y2: -86.8463,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074432986789606959180000003336616376124795304_)"
    },
    d: "M3187.8,2362.89 c0,303.2-245.77,549-548.97,549c-147.91,0-282.15-58.49-380.84-153.63c-103.66-99.83-168.16-240.08-168.16-395.37 c0-303.2,245.81-548.97,549-548.97c90.9,0,176.62,22.09,252.09,61.18C3067.29,1966.42,3187.8,2150.59,3187.8,2362.89z"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 2638.79,
    cy: 2362.89,
    rx: 487.66,
    ry: 487.66
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003094604008693064220000006223479846769093526_",
    gradientUnits: "userSpaceOnUse",
    x1: 1624.3817,
    y1: -270.0814,
    x2: 1886.8405,
    y2: 126.5892,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003094604008693064220000006223479846769093526_)"
    },
    d: "M1927.24,3134.91l-26,2.04 c-6.76,0.53-13.51,0.27-20.18-0.84l-103.11-16.8l-1.69-0.27l-119.82-19.55l-0.74-0.05l-93.89-15.2v-528.29l94.46-0.06h0.18 l119.82,5.96l1.78,0.89l144.93,5.58L1927.24,3134.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047019346637626573730000007104715542823296933_",
    gradientUnits: "userSpaceOnUse",
    x1: 2032.5103,
    y1: 17.8214,
    x2: 1835.4135,
    y2: 334.8441,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047019346637626573730000007104715542823296933_)"
    },
    d: "M2291.84,2589.59v493.08 c0,17.64-13.55,32.06-31.08,33.1l-343.88,20.46c-13.91,0.83-25.78-10.72-25.78-25.06v-513.71c0-14.35,11.25-26.25,25.21-26.64 l346.36-9.65C2278.74,2560.73,2291.84,2573.48,2291.84,2589.59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099619668585054524840000002314770581114930363_",
    gradientUnits: "userSpaceOnUse",
    x1: 1963.1647,
    y1: -537.5573,
    x2: 1902.3199,
    y2: -323.1526,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000099619668585054524840000002314770581114930363_)"
    },
    points: "1562.56,2555.97  1891.1,2571.53 2262.67,2561.17 1881.72,2548.76  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054249359766110004870000009385605609952267145_",
    gradientUnits: "userSpaceOnUse",
    x1: 2270.082,
    y1: -316.7099,
    x2: 1882.579,
    y2: 337.7395,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000054249359766110004870000009385605609952267145_)",
      enableBackground: "new"
    },
    d: " M2262.18,2561.19l-271.26,7.56c-15.43,0.43-28.03,13.45-28.01,29.21c0.03,26.31,4.42,53.5,16,79.74 c38.61,87.47,124.93,90.69,142.89,170.98c14.96,66.89-38.02,95.67-43.62,181.15c-1.47,22.45,0.47,46.61,7.16,72.51 c3.52,13.63,16.19,22.92,30.01,22.1l149.34-8.88c15.32-0.91,27.16-13.5,27.16-28.92V2590.1 C2291.84,2573.7,2278.52,2560.73,2262.18,2561.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016786671135771361140000006735215976268665232_",
    gradientUnits: "userSpaceOnUse",
    x1: 2027.2466,
    y1: -312.8776,
    x2: 2183.1907,
    y2: 472.7259,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000016786671135771361140000006735215976268665232_)"
    },
    points: "2011.63,3130.59  2139.13,3123.01 2139.13,2564.62 2011.63,2568.17  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059279085632311547000000010168147649712222876_",
    gradientUnits: "userSpaceOnUse",
    x1: 2050.8916,
    y1: -68.4434,
    x2: 2327.1106,
    y2: -109.2928,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000059279085632311547000000010168147649712222876_)"
    },
    points: "2017.38,3130.25  2139.13,3123.01 2139.13,2564.62 2017.38,2568.01  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135684059138178040310000016577992300057607082_",
    gradientUnits: "userSpaceOnUse",
    x1: 1691.5162,
    y1: -74.4906,
    x2: 1955.1597,
    y2: -113.4801,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000135684059138178040310000016577992300057607082_)"
    },
    points: "1774.56,2563.56  1774.56,3119.32 1657.76,3099.49 1657.76,2560.41 1694.96,2559.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041262180452036922800000002625031566734672797_",
    gradientUnits: "userSpaceOnUse",
    x1: 1865.2346,
    y1: -347.5466,
    x2: 2451.2878,
    y2: -434.2165,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000041262180452036922800000002625031566734672797_)"
    },
    points: "1786.54,2550.91  2141.96,2571.12 2014.18,2571.12 1703.44,2552.79  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108296058334570481930000005733648328256549053_",
    gradientUnits: "userSpaceOnUse",
    x1: 2162.2869,
    y1: -519.5635,
    x2: 2017.0808,
    y2: -368.5491,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108296058334570481930000005733648328256549053_)"
    },
    d: "M1959.48,2533.85 c8.28-50.7,14.32-87.75,47.43-121.97c13.96-14.43,29.21-30.19,54.21-34.37c28.75-4.81,65.45,6.53,75.51,30.01 c9.55,22.3-12.94,36.83-3.39,62.44c9.6,25.74,37.59,25.19,40.66,45.98c2.6,17.61-14.59,37.59-31.95,46.95 c-29.97,16.17-46.98-6.58-105.52-2.9c-40.34,2.53-63.62,15.3-74.54,2.42C1956.7,2556.28,1957.21,2547.76,1959.48,2533.85z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st63"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126319266283025812580000003961696921551002786_",
    gradientUnits: "userSpaceOnUse",
    x1: 2185.6682,
    y1: -497.0815,
    x2: 2040.4614,
    y2: -346.0665,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126319266283025812580000003961696921551002786_)"
    },
    d: "M2119.69,2514.01 c-36.14-13.82-54.66-43.9-70.67-36.79c-14.22,6.32-5.55,32.72-22.27,54.21c-15.27,19.62-43.27,24.29-68.15,24.31 c0.63,2.51,1.65,4.73,3.29,6.67c10.92,12.88,34.2,0.11,74.54-2.42c58.53-3.67,75.55,19.07,105.52,2.9 c15.92-8.59,31.66-26.11,32.15-42.55C2157.22,2522.16,2138.44,2521.18,2119.69,2514.01z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018924124733220253410000013345046032151521450_",
    gradientUnits: "userSpaceOnUse",
    x1: 1819.1893,
    y1: -459.3648,
    x2: 2204.8296,
    y2: -516.3962,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018924124733220253410000013345046032151521450_)"
    },
    d: "M1741.19,2408.49 c24.31-19.19,49.94,2.21,79.86-18.88c30.31-21.36,21.51-55.63,45.01-65.34c27.31-11.29,67.77,23.16,87.12,45.01 c49.17,55.52,72.26,154.09,33.4,188.77c-14.59,13.01-55.89,7.65-137.91-3.61c-93.74-12.87-107.23-22.08-116.21-34.15 C1708.3,2487.79,1713.67,2430.21,1741.19,2408.49z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st63"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165952226085201986130000014060981086705623440_",
    gradientUnits: "userSpaceOnUse",
    x1: 1823.677,
    y1: -429.0197,
    x2: 2209.3167,
    y2: -486.0509,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165952226085201986130000014060981086705623440_)"
    },
    d: "M1895.11,2450.12 c-13.51-4.26-19.66,11.2-47.43,17.42c-5.1,1.14-54.07,11.37-80.35-19.36c-10.43-12.19-15.32-28.59-14.75-45.98 c-3.83,1.33-7.63,3.33-11.39,6.29c-27.52,21.72-32.89,79.3-8.71,111.81c8.97,12.06,22.46,21.28,116.21,34.15 c82.01,11.26,123.32,16.62,137.91,3.61c1.96-1.75,3.72-3.7,5.37-5.76c-19.68-0.65-40.32-5.41-55.23-19.89 C1907.98,2504.46,1918.08,2457.36,1895.11,2450.12z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025433044192383455720000008217741682043563959_",
    gradientUnits: "userSpaceOnUse",
    x1: 1746.3663,
    y1: -352.3325,
    x2: 2075.1685,
    y2: -400.958,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000025433044192383455720000008217741682043563959_)"
    },
    points: "1900.93,2561.39  1776.27,2566.1 1656.28,2560.41 1695.08,2559.7 1864.94,2556.67  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029033971567940374980000014740561810133711034_",
    gradientUnits: "userSpaceOnUse",
    x1: 2300.7759,
    y1: 1.1703,
    x2: 2418.9778,
    y2: 1.1703,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029033971567940374980000014740561810133711034_)"
    },
    d: "M2308.06,2733.24 c-14.34,10.5-4.51,44.49,3.96,79.14c14.72,60.23,38.73,185.32,30.81,278.15c-0.85,9.91,7.1,18.36,17.05,18.17 c0.22,0,0.43-0.01,0.65-0.01c10.54-0.2,18.19-9.93,16.11-20.26c-7.34-36.54-28.81-89.52-18.13-133.59 c17.93-73.98,68.56-97.06,59.36-144.43C2407.52,2757.11,2330.03,2717.15,2308.06,2733.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091737577706356393800000006692702556136875675_",
    gradientUnits: "userSpaceOnUse",
    x1: 2547.6418,
    y1: -214.4672,
    x2: 2545.6643,
    y2: 100.0215,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091737577706356393800000006692702556136875675_)"
    },
    d: "M2793.05,3026.09 c-2.12-19.61-48.56-16.33-106.79-43.56c-50.49-23.6-56.74-45.31-98.14-89.4c-2.08-2.22-28.35-31.66-63.51-58.64 c-41.57-31.9-46.37-22.75-75.08-45.85c-54.8-44.09-51.5-88.83-107.29-115.77c-7.6-3.67-31.71-15.32-39.47-7.28 c-10.65,11.04,15.29,55.23,40.48,85.11c32.97,39.1,64.13,53.05,88.47,69.6c110.32,75.03,67.74,194.89,167.83,244.96 c54.35,27.18,110.01,13.41,122.67,9.89C2752.84,3066.65,2795.12,3045.23,2793.05,3026.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030465913905501485870000014693723057712565895_",
    gradientUnits: "userSpaceOnUse",
    x1: 2741.054,
    y1: -187.3915,
    x2: 2542.22,
    y2: 147.955,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030465913905501485870000014693723057712565895_)"
    },
    d: "M2298.81,2657.67 c-6.92,3.53-6.87,23.39-6.77,63.12c0.07,29.12,0.48,43.67,4.79,53.61c12.98,29.97,43.74,24.81,95.32,53.8 c7.53,4.24,67.6,38.89,106.49,104.48c19.14,32.28,28.21,61.1,28.21,61.1c17.1,47.11,14.69,70.8,40.05,97.18 c16.54,17.21,43.38,31,207.75,33.64c149.81,2.4,224.72,3.6,230.5-19.79c7.58-30.64-103.71-82.57-146.41-99.92 c-42.81-17.39-64.22-26.08-89.03-21.76c-63.92,11.13-87.21,83.12-127.68,74.57c-11.62-2.45-17.25-9.99-37.61-36.24 c-27.24-35.12-57.27-68.17-82.4-104.82c-39.43-57.49-70.7-96.89-111.41-148.18C2320.58,2655.07,2304.33,2654.86,2298.81,2657.67 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014592745826636901930000012943138300445932701_",
    gradientUnits: "userSpaceOnUse",
    x1: 2741.054,
    y1: -187.3915,
    x2: 2542.22,
    y2: 147.955,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014592745826636901930000012943138300445932701_)"
    },
    d: "M2298.81,2657.67 c-6.92,3.53-6.87,23.39-6.77,63.12c0.07,29.12,0.48,43.67,4.79,53.61c12.98,29.97,43.74,24.81,95.32,53.8 c7.53,4.24,67.6,38.89,106.49,104.48c19.14,32.28,28.21,61.1,28.21,61.1c17.1,47.11,14.69,70.8,40.05,97.18 c16.54,17.21,43.38,31,207.75,33.64c149.81,2.4,224.72,3.6,230.5-19.79c7.58-30.64-103.71-82.57-146.41-99.92 c-42.81-17.39-64.22-26.08-89.03-21.76c-63.92,11.13-87.21,83.12-127.68,74.57c-11.62-2.45-17.25-9.99-37.61-36.24 c-27.24-35.12-57.27-68.17-82.4-104.82c-39.43-57.49-70.7-96.89-111.41-148.18C2320.58,2655.07,2304.33,2654.86,2298.81,2657.67 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183206555998986230520000001232216346198760376_",
    gradientUnits: "userSpaceOnUse",
    x1: 2219.1458,
    y1: 44.042,
    x2: 2337.3477,
    y2: 44.042,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183206555998986230520000001232216346198760376_)"
    },
    d: "M2226.43,2776.11 c-14.34,10.5-4.51,44.49,3.96,79.14c14.72,60.23,38.73,185.32,30.81,278.15c-0.85,9.91,7.1,18.36,17.05,18.17 c0.22,0,0.43-0.01,0.65-0.01c10.54-0.2,18.19-9.93,16.11-20.26c-7.34-36.54-28.81-89.52-18.13-133.59 c17.93-73.98,68.56-97.06,59.36-144.43C2325.89,2799.98,2248.4,2760.03,2226.43,2776.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166639360500755770930000007680977065324219026_",
    gradientUnits: "userSpaceOnUse",
    x1: 2466.0117,
    y1: -171.5952,
    x2: 2464.0342,
    y2: 142.8937,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166639360500755770930000007680977065324219026_)"
    },
    d: "M2711.42,3068.96 c-2.12-19.61-48.56-16.33-106.79-43.56c-50.49-23.6-56.74-45.31-98.14-89.4c-2.08-2.22-28.35-31.66-63.51-58.64 c-41.57-31.9-46.37-22.75-75.08-45.85c-54.8-44.09-51.5-88.83-107.29-115.77c-7.6-3.67-31.71-15.32-39.47-7.28 c-10.65,11.04,15.29,55.23,40.48,85.11c32.97,39.1,64.13,53.05,88.47,69.6c110.32,75.03,67.74,194.89,167.83,244.96 c54.35,27.18,110.01,13.41,122.67,9.89C2671.21,3109.52,2713.49,3088.1,2711.42,3068.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068664159157058556140000010116281059334644364_",
    gradientUnits: "userSpaceOnUse",
    x1: 2554.9565,
    y1: 53.6211,
    x2: 2458.9968,
    y2: 373.1568,
    gradientTransform: "matrix(1 0 0 1 0 2918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068664159157058556140000010116281059334644364_)"
    },
    d: "M2217.18,2700.54 c-6.92,3.53-6.87,23.39-6.77,63.12c0.07,29.12,0.48,43.67,4.79,53.61c12.98,29.97,43.74,24.81,95.32,53.8 c7.53,4.24,67.59,38.89,106.49,104.48c19.14,32.28,28.21,61.1,28.21,61.1c17.1,47.11,14.69,70.8,40.05,97.18 c16.54,17.21,43.38,31,207.75,33.64c149.81,2.4,224.72,3.6,230.5-19.79c7.58-30.64-103.71-82.57-146.41-99.92 c-42.81-17.39-64.22-26.08-89.03-21.76c-63.92,11.13-87.21,83.12-127.68,74.57c-11.62-2.45-17.25-9.99-37.61-36.24 c-27.24-35.12-57.27-68.17-82.4-104.82c-39.43-57.49-70.7-96.89-111.41-148.18C2238.95,2697.94,2222.7,2697.73,2217.18,2700.54z "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093172426298672688090000006278793326048239017_",
    gradientUnits: "userSpaceOnUse",
    x1: 2427.1089,
    y1: 1376.1962,
    x2: 2939.5933,
    y2: 1376.1962,
    gradientTransform: "matrix(1 0 0 -1 0 3708.8662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0229,
    style: {
      stopColor: "#3548A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    style: {
      stopColor: "#1837A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2426,
    style: {
      stopColor: "#182F99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    style: {
      stopColor: "#171984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3504,
    style: {
      stopColor: "#171580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4714,
    style: {
      stopColor: "#100F59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7877,
    style: {
      stopColor: "#1C157B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093172426298672688090000006278793326048239017_)"
    },
    d: "M2856.3,2104.13h82.81 c0,0,22.12,193.92-233.01,336.4c-14.7-47.05-52.47-80.24-102.88-51.95s-26.23,84.87-26.23,84.87 c-24.43,35.73-11.97,85.39-12.08,87.76c-61.76-28.9-191.1-128.91-113.94-308.94c0,0,58.12-125.51,187.75-148.14 c0,0,30.86,80.76,118.82,70.98C2839.84,2165.35,2856.3,2104.13,2856.3,2104.13z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M2856.3,2104.13h82.81c0,0,7.46,65.4-36.25,148.15c-14.44-92.45-507.63-35.04-340.24,262.54 c-2.68,24.11,2.37,44.88,2.29,46.4c-61.76-28.9-191.1-128.91-113.94-308.94c0,0,58.12-125.51,187.75-148.14 c0,0,30.86,80.76,118.82,70.98C2839.84,2165.35,2856.3,2104.13,2856.3,2104.13z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M2856.3,2104.13h82.81c0,0-34.77,78.39-43.49,95.09c-444.66-90.71-488.15,219.9-333.46,340.14 c9.72,7.56,2.8,20.9,2.75,21.86c-61.76-28.9-191.1-128.91-113.94-308.94c0,0,58.12-125.51,187.75-148.14 c0,0,30.86,80.76,118.82,70.98C2839.84,2165.35,2856.3,2104.13,2856.3,2104.13z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M2450.97,2252.28c0,0,58.12-125.51,187.75-148.14c0,0,30.86,80.76,118.82,70.98 c82.3-9.77,98.76-70.98,98.76-70.98h82.81c0,0,22.12,193.92-233.01,336.4c-7.57-24.24-21.27-44.8-39.66-55.17 C2660.69,2382.53,2625.5,2174.75,2450.97,2252.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158717532221244291650000017992159846423782588_",
    gradientUnits: "userSpaceOnUse",
    x1: 2464.3303,
    y1: 1436.5363,
    x2: 2949.5876,
    y2: 1436.5363,
    gradientTransform: "matrix(1 0 0 -1 0 3708.8662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5E900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    style: {
      stopColor: "#DC4900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D60008"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158717532221244291650000017992159846423782588_)"
    },
    d: "M2856.3,2104.13h82.81 c0,0,22.12,193.92-233.01,336.4c0-146.6-123.97-302.45-255.13-188.26c0,0,58.12-125.51,187.75-148.14c0,0,30.86,80.76,118.82,70.98 C2839.84,2165.35,2856.3,2104.13,2856.3,2104.13z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "2589.68,2722.43 2507.72,2660.36 2577.34,2567.09 2659.64,2625.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "2507.72,2660.36 2499.49,2644.76 2577.34,2567.09  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M2634.13,2612.21l-3.07-1.93c0.23-0.37,22.84-36.83,7.76-47.01c-3.65-2.38-7.49-3.05-11.75-2.02 c-15.31,3.71-29.3,28.08-29.44,28.33l-3.16-1.79c0.6-1.06,14.9-25.98,31.74-30.06c5.21-1.26,10.13-0.42,14.62,2.52 C2658.81,2572.4,2635.15,2610.6,2634.13,2612.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "2715.19,2701.17 2614.71,2724.83 2586.94,2612.36 2682.11,2590.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "2614.71,2724.83 2594.17,2716.21 2586.94,2612.36  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M2614.89,2609.76c-0.31-1.18-7.6-28.97,1.53-43.69c2.83-4.55,6.93-7.4,12.18-8.46 c21.34-3.97,31.27,39.85,31.68,41.72l-3.54,0.78c-0.09-0.42-9.57-42.26-27.45-38.94c-4.27,0.86-7.48,3.09-9.79,6.81 c-8.31,13.4-1.18,40.57-1.11,40.84L2614.89,2609.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "2679.87,2564.69 2605.8,2629.16 2681.24,2714.55 2760.46,2649.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "2681.24,2714.55 2659.64,2714.55 2605.8,2629.16  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M2635.33,2612.84c-0.83-0.89-20.33-22-19.18-39.29c0.36-5.35,2.64-9.79,6.78-13.19 c16.97-13.53,46.33,20.49,47.57,21.94l-2.76,2.36c-0.28-0.33-28.3-32.82-42.53-21.48c-3.36,2.76-5.15,6.24-5.44,10.61 c-1.05,15.72,18.02,36.37,18.21,36.58L2635.33,2612.84z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098911626241076234870000002232214297812278180_",
    gradientUnits: "userSpaceOnUse",
    x1: 2546.24,
    y1: 1204.5894,
    x2: 2676.1997,
    y2: 1204.5894,
    gradientTransform: "matrix(1 0 0 -1 0 3708.8662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5E900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D60008"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098911626241076234870000002232214297812278180_)"
    },
    d: "M2573.79,2554.16 c4-3.66,7.77-0.46,7.77-0.46s6.59,5.85,15.15,11.6c3.86-4.87,8.45-9.79,13.6-13.69c-3.86-17.56-6.4-36.79-6.4-36.79 c3.02-18.27,28.63-22.84,35.48-7.53c9.14,23.09-15.09,27.97-15.09,27.97l13.3,9.06c6.37,1.29,12.74,4.64,18.63,8.8 c8.03-15.5,43.4-89.69-5.11-108.59c-90.94-14.98-104.88,106.82-104.88,106.82c6.65,3.9,12.94,7.18,18.66,9.85L2573.79,2554.16z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M2581.57,2553.7c0,0-3.77-3.2-7.77,0.46l-8.88,7.06c-5.71-2.67-12-5.95-18.66-9.85 c0,0,13.94-121.8,104.88-106.82c48.51,18.9,7.97,85.43-0.07,100.93c0,0,33.35-68.19-10.63-68.19 C2596.46,2477.29,2580.04,2502.34,2581.57,2553.7z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements_00000029746840585995367750000007639924101331881149_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M2710.7,2128.49h57.17c0.89,0,1.68-0.6,1.91-1.46l9.63-36c0.16-0.59,0.03-1.23-0.34-1.71 s-0.95-0.77-1.57-0.77h-75.3l-3.28-12.28c-0.13-0.48-0.43-0.89-0.85-1.16l-14.94-9.43c-0.92-0.58-2.14-0.31-2.72,0.62 c-0.58,0.92-0.31,2.14,0.62,2.72l14.29,9.02l3.48,13l9.24,34.53l-4.85,3.44c-0.52,0.37-0.83,0.97-0.83,1.61v8.5 c0,1.09,0.88,1.97,1.97,1.97h70.43c1.09,0,1.97-0.88,1.97-1.97s-0.88-1.97-1.97-1.97h-68.45v-5.5L2710.7,2128.49z  M2774.92,2092.49l-8.57,32.06h-54.52l-8.58-32.06H2774.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M2717.02,2142.83c-4.69,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5s8.5-3.81,8.5-8.5 S2721.71,2142.83,2717.02,2142.83z M2717.02,2155.88c-2.51,0-4.55-2.04-4.55-4.55s2.04-4.55,4.55-4.55s4.55,2.04,4.55,4.55 C2721.58,2153.84,2719.53,2155.88,2717.02,2155.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M2760.94,2142.83c-4.69,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5s8.5-3.81,8.5-8.5 S2765.62,2142.83,2760.94,2142.83z M2760.94,2155.88c-2.51,0-4.55-2.04-4.55-4.55s2.04-4.55,4.55-4.55s4.55,2.04,4.55,4.55 C2765.49,2153.84,2763.45,2155.88,2760.94,2155.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M2765.74,2070.69l-42.18-6.18c-1.08-0.16-2.08,0.59-2.24,1.67l-6.49,44.25c-0.16,1.08,0.59,2.08,1.67,2.24 l42.18,6.18c1.08,0.16,2.08-0.59,2.24-1.67l6.49-44.25C2767.57,2071.85,2766.82,2070.85,2765.74,2070.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M2712.47,2097.01h69.27c1.32,0,2.27,1.28,1.89,2.55l-8.73,32.53c-0.25,0.83-1.02,1.4-1.89,1.4h-53.91 c-0.92,0-1.72-0.64-1.92-1.53l-6.63-32.53C2710.26,2098.19,2711.2,2097.01,2712.47,2097.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 2723.55,
    cy: 2152.44,
    r: 8.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 2767.86,
    cy: 2152.44,
    r: 8.19
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M2856.3,2104.13h82.81c0,0-27.91,190.14-269.71,197.59c-46.38-81.49-130.8-125.74-218.43-49.45 c0,0,58.12-125.51,187.75-148.14c0,0,30.86,80.76,118.82,70.98C2839.84,2165.35,2856.3,2104.13,2856.3,2104.13z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M2856.3,2104.13h82.81c0,0-111.09,118.65-226.64,89.71c-101.31-25.38-173.87-17.86-261.5,58.43 c0,0,58.12-125.51,187.75-148.14c0,0,30.86,80.76,118.82,70.98C2839.84,2165.35,2856.3,2104.13,2856.3,2104.13z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 2633.85,
    cy: 2129.57,
    r: 8.35
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M2626.49,2535.21c18.95,0,94.1-17.56,24.64-90.66c-10.41-1.71-24.1-1.02-28.29-0.16 C2668.55,2447.37,2676.21,2522.52,2626.49,2535.21z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 2866.12,
    cy: 2124.54,
    r: 8.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 2660.69,
    cy: 2159.83,
    r: 8.35
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 2688.44,
    cy: 2177.89,
    r: 8.35
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 2723.55,
    cy: 2190.87,
    r: 8.35
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 2840.95,
    cy: 2157.47,
    r: 8.35
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 2806.06,
    cy: 2180.17,
    r: 8.35
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 2770.25,
    cy: 2190.87,
    r: 8.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132047468007413859970000015415337781645311651_",
    gradientUnits: "userSpaceOnUse",
    x1: 2603.9199,
    y1: 1194.046,
    x2: 2603.9199,
    y2: 1194.046,
    gradientTransform: "matrix(1 0 0 -1 0 3708.8662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#329D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4201,
    style: {
      stopColor: "#4BAB27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73C31E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132047468007413859970000015415337781645311651_)"
    },
    d: "M2603.92,2514.82L2603.92,2514.82 L2603.92,2514.82z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045580391807168135140000005508131796759066523_",
    gradientUnits: "userSpaceOnUse",
    x1: 2649.1741,
    y1: 1206.5261,
    x2: 2749.8237,
    y2: 1206.5261,
    gradientTransform: "matrix(1 0 0 -1 0 3708.8662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    style: {
      stopColor: "#3548A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    style: {
      stopColor: "#1837A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2426,
    style: {
      stopColor: "#182F99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    style: {
      stopColor: "#171984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3504,
    style: {
      stopColor: "#171580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5043,
    style: {
      stopColor: "#0D0C49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7877,
    style: {
      stopColor: "#1C157B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045580391807168135140000005508131796759066523_)"
    },
    d: "M2631.66,2543.77c0.17,0,0.34,0,0.51,0 c11.8,0,24.14,8.47,33.73,17.2l9.01-7.84c3.05-2.65,7.64-2.44,10.43,0.48l2.59,2.71c10.85-12.01,17.46-27.93,17.46-45.39 c0-34.6-25.95-63.14-59.44-67.22c16.92,8.52,26.2,30.25,21.24,52.7c-5.72,25.87-28.18,42.89-50.17,38.03 c-7.18-1.59-10.89-7.2-12.43-14.94c0.99,6.77,3.04,19.85,5.74,32.11c4.34-3.29,9.08-5.86,14.11-7.08 C2626.84,2543.94,2629.27,2543.69,2631.66,2543.77z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2603.92,2514.82L2603.92,2514.82L2603.92,2514.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2645.94,2443.71c33.5,4.09,59.44,32.62,59.44,67.22c0,17.46-6.61,33.38-17.46,45.39l-2.59-2.71 c-2.79-2.92-7.38-3.13-10.43-0.48l-9.01,7.84c-3.71-3.38-7.83-6.71-12.17-9.54C2653.73,2551.43,2733.12,2489.35,2645.94,2443.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088821690826046361490000018200378939548693928_",
    gradientUnits: "userSpaceOnUse",
    x1: 2603.9199,
    y1: 1194.046,
    x2: 2603.9199,
    y2: 1194.046,
    gradientTransform: "matrix(1 0 0 -1 0 3708.8662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#329D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4201,
    style: {
      stopColor: "#4BAB27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73C31E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088821690826046361490000018200378939548693928_)"
    },
    d: "M2603.92,2514.82L2603.92,2514.82 L2603.92,2514.82z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M2604.58,2519.5c0.99,6.77,3.04,19.85,5.74,32.11c4.34-3.29,9.08-5.86,14.11-7.08 C2607.46,2534.88,2606.12,2527.24,2604.58,2519.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImg);
export default __webpack_public_path__ + "static/media/login-img.e6104e34e82e52ba80007d7da7bb1578.svg";
export { ForwardRef as ReactComponent };